import { WorkMaterialStatus } from './work-material-status.interface';
import { WorkMaterialStatusService } from './work-material-status.service';

const service = new WorkMaterialStatusService();

export interface WorkMaterialStatusState {
   workMaterialStatuses: Array<WorkMaterialStatus>;
}

const state: WorkMaterialStatusState = {
   workMaterialStatuses: [],
};

const getters = {
   workMaterialStatuses(state: WorkMaterialStatusState) {
      return state.workMaterialStatuses;
   },
};

const mutations = {
   SET_WORK_MATERIAL_STATUSES(state: WorkMaterialStatusState, workMaterialStatuses: Array<WorkMaterialStatus>) {
      state.workMaterialStatuses = workMaterialStatuses;
   },
};

const actions = {
   async getWorkMaterialStatuses(context: any) {
      const response = await service.getWorkMaterialStatuses();
      context.commit('SET_WORK_MATERIAL_STATUSES', response.data);
      return response.data;
   },
};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
